import { Col, Input, Row, Select, Tooltip, message, Button } from 'antd'
import React, { useState } from 'react';
import { CSVLink } from "react-csv"
import moment from 'moment';
const { Option } = Select;

const ReportFilter = ({searchHide, filter, setFilter, setPage, setOffset , headers, FilteredData, setFilteredData = (val) => { } }) => {
    const [values, setValues] = useState({
        searchString: "",
        fromDate: "",
        toDate: "",
        facilityId: "",
        facilityName: "",
    });
    const handleChange = (name, value) => {
        setValues({ ...values, [name]: value });
    }
    const handleFilter = () => {
        setFilter({ ...filter, ...values });
        setPage(1);
        // setOffset(0);
    }
    const handleFilterReset = () => {
        setFilter({});
        setValues({
            ...values,
            searchString: "",
            fromDate: "",
            toDate: "",
            sentStatus: "",
            facilityId: "",
            facilityName: "",
        })
        setPage(1);
    }

    // Fields share the row; buttons keep their size (one line on desktop)
    const FIELD = "1 1 150px";
    const field = (label, input) => (
        <Col flex={FIELD} style={{ minWidth: 150 }}>
            <strong><p className="mb-2">{label}</p></strong>
            {input}
        </Col>
    );

    return (
        <div className="table_filter">
            <Row gutter={[16, 16]} align="bottom" wrap className="ml-10">
                {field("From Date",
                    <Input
                        type="date"
                        id="fromdate"
                        autoComplete="off"
                        className="form-control"
                        onChange={(e) => handleChange("fromDate", e.target.value)}
                        max={moment().format("YYYY-MM-DD")}
                        placeholder="From Date"
                        value={values?.fromDate}
                    />
                )}
                {field("To Date",
                    <Input
                        type="date"
                        id="todate"
                        autoComplete="off"
                        className="form-control"
                        onChange={(e) => handleChange("toDate", e.target.value)}
                        min={values?.fromDate}
                        placeholder="To Date"
                        value={values?.toDate}
                    />
                )}
                {!searchHide && field("Search",
                    <Input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        onChange={(e) => handleChange("searchString", e.target.value)}
                        placeholder="Search"
                        value={values?.searchString}
                    />
                )}
                {field("Facility ID",
                    <Input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        onChange={(e) => handleChange("facilityId", e.target.value)}
                        placeholder="e.g. IN0910034462"
                        value={values?.facilityId}
                    />
                )}
                {field("Facility Name",
                    <Input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        onChange={(e) => handleChange("facilityName", e.target.value)}
                        placeholder="Facility Name"
                        value={values?.facilityName}
                    />
                )}
                {field("Status",
                    <Select
                        className="text-capitalize w-100"
                        placeholder="Select Status"
                        onChange={(value) => handleChange("sentStatus", value)}
                        value={values?.sentStatus}
                    >
                        <Option className="text-capitalize" value="">All</Option>
                        <Option className="text-capitalize" value={0}>Pending</Option>
                        <Option className="text-capitalize" value={1}>Linked</Option>
                    </Select>
                )}
                <Col flex="none">
                    <div className="flex gap10" style={{ flexWrap: "nowrap", alignItems: "center" }}>
                        <button className="filter-button" onClick={() => handleFilter()}>Filter</button>
                        <button className="clear-button" onClick={() => handleFilterReset()}>Reset</button>
                        <CSVLink
                            filename={"Care Context.csv"}
                            data={FilteredData}
                            headers={headers}
                            className="ex-export2 mt-0"
              style={{ right: 0, marginTop: 0 }}
                            onClick={() => {
                                message.success("The file is downloading")
                            }}
                        >
                            <Tooltip placement="top" title={"A user can download only single page data once."} arrow={false}>
                                <Button className="export-csv"> Export to CSV </Button>
                            </Tooltip>
                        </CSVLink>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default ReportFilter